import Axios from 'axios'
import { getPathName, getApiHash, getApiToken } from './helper';

const obtenerVersiones = async (marca, modelo, anio, rubro = "auto") => {
    const params = {
        hash: await getApiHash(),
        marca: marca?.label,
        modelo: modelo?.label,
        anio: anio?.value,
        rubro
    }
    const headers = { 
        'content-type': 'application/json',
        "Authorization" : 'Bearer ' + await getApiToken()
    }
    return await Axios.post(await getPathName() + "/getversionjson", params,
        {
            headers: headers
        }).then(function (response) {
            return response.data.versiones;
        }).catch(function (error) {
            return error;
    });
};

export default obtenerVersiones;